import { CrudPage } from "@/components/admin/CrudPage";
import { F, In, Num, Area, Lines, Sel, Toggle, Pill } from "@/components/admin/kit";
import { priceInfo } from "@/lib/format";

const BLANK = {
  name: "", slug: "", category: "Complex", summary: "", description: "", deliverables: [], exclusions: [], price_inr: null, custom_quote: true,
  price_unit: "per video", durations: [], aspect_ratios: [], platforms: [], revision_limit: null, turnaround_text: "", turnaround_hours: null,
  featured: false, available: true, published: false,
};

const ServiceForm = ({ value: v, set }) => (
  <div className="grid md:grid-cols-2 gap-4">
    <F label="Name"><In value={v.name} onChange={set("name")} testid="service-name" /></F>
    <F label="Category"><Sel value={v.category} onChange={set("category")} options={["Simple", "Complex", "Premium"]} testid="service-category" /></F>
    <F label="Summary (cards)" className="md:col-span-2"><In value={v.summary} onChange={set("summary")} testid="service-summary" /></F>
    <F label="Description (service page)" className="md:col-span-2"><Area value={v.description} onChange={set("description")} testid="service-description" /></F>
    <div className="md:col-span-2 border border-[#27272A] p-4 grid md:grid-cols-3 gap-4">
      <div className="md:col-span-3"><Toggle label="Custom quote (hide price)" checked={v.custom_quote} onChange={set("custom_quote")} testid="service-custom-quote" /></div>
      <F label="Starting price (₹)"><Num value={v.price_inr} onChange={set("price_inr")} min={0} disabled={v.custom_quote} testid="service-price" /></F>
      <F label="Price unit"><In value={v.price_unit} onChange={set("price_unit")} placeholder="per reel" testid="service-price-unit" /></F>
      <F label="Revision limit" hint="Empty = as agreed"><Num value={v.revision_limit} onChange={set("revision_limit")} min={0} testid="service-revisions" /></F>
    </div>
    <F label="Deliverables"><Lines value={v.deliverables} onChange={set("deliverables")} testid="service-deliverables" /></F>
    <F label="Exclusions"><Lines value={v.exclusions} onChange={set("exclusions")} testid="service-exclusions" /></F>
    <F label="Eligible durations"><Lines value={v.durations} onChange={set("durations")} rows={2} testid="service-durations" /></F>
    <F label="Aspect ratios"><Lines value={v.aspect_ratios} onChange={set("aspect_ratios")} rows={2} testid="service-ratios" /></F>
    <F label="Platforms"><Lines value={v.platforms} onChange={set("platforms")} rows={2} testid="service-platforms" /></F>
    <F label="Standard first-draft hours" hint="Used to set the deadline when the clock starts. Empty = confirmed in scoping"><Num value={v.turnaround_hours} onChange={set("turnaround_hours")} min={1} testid="service-turnaround-hours" /></F>
    <F label="Turnaround terms (public)" className="md:col-span-2"><In value={v.turnaround_text} onChange={set("turnaround_text")} testid="service-turnaround-text" /></F>
    <div className="md:col-span-2 grid md:grid-cols-3 gap-x-6">
      <Toggle label="Published" checked={v.published} onChange={set("published")} testid="service-published" />
      <Toggle label="Featured" checked={v.featured} onChange={set("featured")} testid="service-featured" />
      <Toggle label="Available (uncheck = temporarily unavailable)" checked={v.available} onChange={set("available")} testid="service-available" />
    </div>
  </div>
);

const Row = (s) => {
  const p = priceInfo(s);
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
      <p className="font-semibold">{s.name}</p><Pill status={s.category} />
      <p className="text-sm text-[#00E5FF]" data-testid={`admin-service-price-${s.slug}`}>{p.custom ? "Custom quote" : `${p.main} ${p.unit}`}</p>
      {!s.published && <span className="text-xs text-zinc-600">Draft</span>}{s.featured && <span className="text-xs text-zinc-500">Featured</span>}{!s.available && <span className="text-xs text-amber-400">Unavailable</span>}
    </div>
  );
};

export default function ServicesAdmin() {
  return (
    <div>
      <CrudPage endpoint="services" title="Services & pricing" eyebrow="Content" label="Service" blank={BLANK} Form={ServiceForm} renderRow={Row} testid="admin-services" />
      <p className="mt-6 text-xs text-zinc-500">GST display, promo text and scope notes live under Site content → Pricing. Prices on existing quotes and projects are locked and never change when you edit a service.</p>
    </div>
  );
}
